import { enterpriseLastMileDelivery } from '../../utils/content-settings';
import { checkContentSettingsForChangesOnSave } from '../../utils/password';

export default function ModalEditContentSettingsController(
  $uibModal,
  $uibModalInstance,
  $cacheFactory,
  $rootScope,
  Account,
  $httpParamSerializer,
  $sce,
  toaster,
  parentVM
) {
  'ngInject';

  this.cancel = () => $uibModalInstance.dismiss('cancel');

  this.account = angular.copy(parentVM.account);
  this.FeatureFlags = parentVM.FeatureFlags;

  this.activeTab = '';

  this.content_settings = this.account.content_settings;
  this.showPoster = this.content_settings.poster;
  this.showPreroll = this.content_settings.customPreroll;

  this.onLoadImage = (which, $event) => {
    this[which] = $event.target;
  };

  this.onChangeImage = (which) => {
    this.content_settings[which] = null;
    this[which] = null;
  };

  this.onShowInAppsClick = () => {
    this.account.enable_public_discovery = !this.account.enable_public_discovery;
    if (this.account.enable_public_discovery && !this.content_settings.display_name) {
      this.content_settings.display_name = this.account.name;
    }
  };

  this.uploadIntoCS = (key, file) => {
    file.upload().then((response) => {
      console.log(response);
      if (key.indexOf('.') >= 0) {
        setValue(key, response.view_url, this.content_settings);
      } else {
        this.content_settings[key] = response.view_url;
      }
    });
  };

  this.showPublicAppSettingsWarning = () => {
    if (!this.account.enable_public_discovery) {
      return false;
    } else {
      return !(this.content_settings.thumb_img && this.content_settings.logo_img);
    }
  };

  this.enterpriseLastMileDelivery = () => {
    return enterpriseLastMileDelivery(this.account);
  };

  this.update = () => {
    this.showError = false;
    this.saving = true;

    var data = angular.copy(this.content_settings);

    // Remove as many keys as we can to keep the payload small when sent to the player
    if (!_.trim(data.donateMessage)) delete data.donateMessage;
    if (!this.showPoster) delete data.poster;
    if (!this.showPreroll) delete data.customPreroll;
    if (!data.hide_linkback) delete data.hide_linkback;

    // If they set up the app, make sure we don't have a null thumb/image
    const enablePublicDiscovery = this.account.enable_public_discovery;
    if (enablePublicDiscovery && !(data.thumb_img && data.logo_img)) {
      this.showError = true;
      this.saving = false;
      toaster.pop('warning', 'Please fill in all BoxCast App Settings fields, including logos.');
      return false;
    }

    // Look at possible password changes.
    checkContentSettingsForChangesOnSave(data);

    Account.update(
      { content_settings: data, enable_public_discovery: enablePublicDiscovery },
      (account) => {
        // Invalidate cache
        $cacheFactory.get('$http').remove(`${API_ROOT}/account`);
        $rootScope.account = account;
        parentVM.refresh();
        this.cancel();
      },
      () => {
        this.saving = false;
        alert('There was an error trying to save the settings. Please try again.');
      }
    );
  };
}

function setValue(path, val, obj) {
  var fields = path.split('.');
  var result = obj;
  for (var i = 0, n = fields.length; i < n && result !== undefined; i++) {
    var field = fields[i];
    if (i === n - 1) {
      result[field] = val;
    } else {
      if (typeof result[field] === 'undefined' || !_.isObject(result[field])) {
        result[field] = {};
      }
      result = result[field];
    }
  }
}



// WEBPACK FOOTER //
// ./app/pages/settings/modal-edit-content-settings.js